module.exports = __webpack_public_path__ + "static/img/supervise.0d9d0dcb.png";